import { render, staticRenderFns } from "./OmzetExport_List.vue?vue&type=template&id=c525193a&"
import script from "./OmzetExport_List.vue?vue&type=script&lang=js&"
export * from "./OmzetExport_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports